<template>
    <v-col cols="auto" class="od-os-ou-buttons">
      <v-btn text
        class="modal-cta"
        :class="[{ active: isOD }, colorClass]"
        @click="$emit('selectEye', 'OD')">OD</v-btn>
      <v-btn text
        class="modal-cta"
        :class="[{ active: isOS }, colorClass]"
        @click="$emit('selectEye', 'OS')">OS</v-btn>
      <v-btn text
        class="modal-cta"
        :class="[{ active: isOUU }, colorClass]"
        @click="$emit('selectEye', 'OU')">OU/U</v-btn>
    </v-col>
</template>

<script>
import { EyeTypes } from "../../../config/config";
export default {
  name: "odOsOuButtons",
  props: ["eye"],
  computed:{
    isOD(){ return this.eye === EyeTypes.OD; },
    isOS() { return this.eye === EyeTypes.OS; },
    isOUU() { return this.eye === EyeTypes.OU ||this.eye === EyeTypes.U; }
  }
}
</script>